import React, { useContext } from 'react';
import { useLocation } from 'react-router';
import './styles/header.css'
import Context from '../context.js'


function HeaderMobile({ title, value, type, onClick, active }) {

  let config = window.config;

  return (

    <div className="header-mobile">
      <div className="header-mobile__container">
        <div className="header-mobile__profile-block">
          <div className="header-mobile__logo">
            <a href={config.site_url} target={"_bank"}><img src={config.logo} alt="" /></a>
          </div>
        </div>
      </div>
    </div>
  )


}

export default HeaderMobile;